import React, { useState } from 'react';
import Cancel from '../../../../media/cancel_2.png';
import Add from '../../../../media/add.png';
import Remove from '../../../../media/delete.png';
import Correct from '../../../../media/correct.png';

function ExamManager({ examData, setExamData, deletedQuestionIds, setDeletedQuestionIds, deletedChoiceIds, setDeletedChoiceIds, saving, errors }) {
  const addQuestion = () => {
    setExamData(prev => ({
      ...prev,
      questions: [
        ...prev.questions,
        {
          id: crypto.randomUUID(),
          question_text: '',
          type: 'multiple',
          choices: [
            { id: crypto.randomUUID(), choice_text: '', correct: false },
            { id: crypto.randomUUID(), choice_text: '', correct: false },
          ],
        },
      ],
    }));
  };

  const removeQuestion = (qIndex) => {
    setExamData(prev => {
      const questionToRemove = prev.questions[qIndex];
      if (questionToRemove.id) setDeletedQuestionIds(dq => [...dq, questionToRemove.id]);
      const questions = prev.questions.filter((_, i) => i !== qIndex);
      return { ...prev, questions };
    });
  };

  const handleQuestionChange = (qIndex, field, value) => {
    setExamData(prev => {
      const questions = prev.questions.map((q, i) => {
        if (i !== qIndex) return q;
        let updated = { ...q, [field]: value };

        
        if (field === 'type') {
          if (value === 'truefalse') {
            updated.choices = [
              { id: crypto.randomUUID(), choice_text: 'Vero', correct: false },
              { id: crypto.randomUUID(), choice_text: 'Falso', correct: false },
            ];
          } else {
        
            updated.choices = [
              { id: crypto.randomUUID(), choice_text: '', correct: false },
              { id: crypto.randomUUID(), choice_text: '', correct: false },
            ];
          }
        }

        return updated;
      });
      return { ...prev, questions };
    });
  };

  const handleChoiceChange = (qIndex, choiceId, field, value) => {
    setExamData(prev => {
      const questions = prev.questions.map((q, i) => {
        if (i !== qIndex) return q;

        const choices = q.choices.map(c => {
      
          if (field === 'correct') {
            return {
              ...c,
              correct: c.id === choiceId ? value : false
            };
          }

        
          return c.id === choiceId
            ? { ...c, [field]: value }
            : c;
        });

        return { ...q, choices };
      });

      return { ...prev, questions };
    });
  };

  const addChoice = (qIndex) => {
    setExamData(prev => {
      const questions = prev.questions.map((q, i) => {
        if (i !== qIndex) return q;
        return {
          ...q,
          choices: [
            ...q.choices,
            { id: crypto.randomUUID(), choice_text: '', correct: false }
          ],
        };
      });
      return { ...prev, questions };
    });
  };

  const removeChoice = (qIndex, choiceId) => {
    setExamData(prev => {
      const questions = prev.questions.map((q, i) => {
        if (i !== qIndex) return q;

        if (q.choices.length <= 2) return q; 

        const choiceToRemove = q.choices.find(c => c.id === choiceId);
        if (choiceToRemove?.id) setDeletedChoiceIds(dl => [...dl, choiceToRemove.id]);

        return { ...q, choices: q.choices.filter(c => c.id !== choiceId) };
      });
      return { ...prev, questions };
    });
  };

  return (
    <div>
      <h3>Esame del Modulo</h3>

      <label>Punteggio minimo per passare</label>
      <input
        type="number"
        value={examData.min_score_to_pass}
        onChange={e => setExamData({ ...examData, min_score_to_pass: e.target.value })}
        onWheel={(e) => e.currentTarget.blur()}
        placeholder="Punteggio minimo"
        disabled={saving}
      />
      {errors.exam_min_score_to_pass && <small>{errors.exam_min_score_to_pass}</small>}

      <label>Numero di domande</label>
      <input
        type="number"
        value={examData.num_questions}
        onChange={e => setExamData({ ...examData, num_questions: e.target.value })}
        onWheel={(e) => e.currentTarget.blur()}
        placeholder="Numero di domande"
        disabled={saving}
      />
      {errors.num_questions && <small>{errors.num_questions}</small>}

      <label>Tempo limite (minuti)</label>
      <input
        type="number"
        value={examData.time_limit_minutes}
        onChange={e => setExamData({ ...examData, time_limit_minutes: e.target.value })}
        onWheel={(e) => e.currentTarget.blur()}
        placeholder="Tempo limite opzionale"
        disabled={saving}
      />
      {errors.time_limit_minutes && <small>{errors.time_limit_minutes}</small>}

      <div style={{ marginTop: "20px" }}>
  
      <label style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        <input
          type="checkbox"
          checked={examData.shuffle_questions || false}
          onChange={(e) =>
            setExamData({
              ...examData,
              shuffle_questions: e.target.checked
            })
          }
          disabled={saving}
        />
        Randomizza domande
      </label>

      <label style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "10px" }}>
        <input
          type="checkbox"
          checked={examData.shuffle_choices || false}
          onChange={(e) =>
            setExamData({
              ...examData,
              shuffle_choices: e.target.checked
            })
          }
          disabled={saving}
        />
         Randomizza risposte
      </label>

    </div>

      {examData.questions.map((q, qIndex) => (
        <div key={q.id} className="lesson-card" style={{marginTop: "40px"}}>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <button   type="button" onClick={() => removeQuestion(qIndex)} disabled={saving}>
               <img src={Remove}  alt="cancel" style={{ width: 16, height: 16}} />
            </button>
          </div>
          {errors[`correct_${qIndex}`] && (
                <span className="error2">
                  {errors[`correct_${qIndex}`][0]}
                </span>
              )}
          <label>Domanda #{qIndex + 1}</label>
          <input
            type="text"
            value={q.question_text}
            onChange={e => handleQuestionChange(qIndex, 'question_text', e.target.value)}
            placeholder="Testo della domanda"
            disabled={saving}
            className={`input ${errors[`question_text_${qIndex}`] ? "error" : ""}`}
          />
            {errors[`question_text_${qIndex}`] && (
            <span className="error">{errors[`question_text_${qIndex}`]}</span>
            )}
          

          <label>Tipo di domanda</label>
          <select value={q.type} onChange={e => handleQuestionChange(qIndex, 'type', e.target.value)} disabled={saving} >
             <option value="multiple">Scelta multipla</option>
              <option value="truefalse">Vero/Falso</option>
          </select>

          {q.choices.map((c, ci) => (
            <div>
            <div key={c.id} style={{ display: 'flex', alignItems: 'center', marginTop: '0.5rem', marginBottom: '-10px' }}>
              <input
                type="text"
                value={c.choice_text}
                onChange={e => handleChoiceChange(qIndex, c.id, 'choice_text', e.target.value)}
                placeholder="Scelta"
                style={{ flex: 1, marginRight: '0.5rem', marginBottom: "20px" }}
                disabled={saving}
                className={`input ${errors[`choice_${qIndex}_${ci}`] ? "error" : ""}`}
              />
              <label style={{  display: 'flex', alignItems: 'center', gap: '10px', marginTop: "-10px" }}>
                <img src={Correct}  alt="cancel" style={{ width: 32, height: 32}} />
                <input
                  type="checkbox"
                  checked={c.correct}
                  onChange={e => handleChoiceChange(qIndex, c.id, 'correct', e.target.checked)}
                  disabled={saving}
                />
              </label>
              {q.type !== 'truefalse' && (
                <button style={{ marginLeft: "30px", marginTop: "-20px"}}  type="button" onClick={() => removeChoice(qIndex, c.id)} disabled={saving || q.choices.length <= 2}>
                  <img src={Cancel}  alt="cancel" style={{ width: 16, height: 16}} />
                </button>
              )}
            </div>
             {errors[`choice_${qIndex}_${ci}`] && (
                <span className='error'>
                  {errors[`choice_${qIndex}_${ci}`][0]}
                </span>
              )}
            </div>

          ))}

          {q.type === 'multiple' && (
            <button  type="button" onClick={() => addChoice(qIndex)} disabled={saving}>
              <img src={Add}  alt="cancel" style={{ width: 16, height: 16}} />
            </button>
          )}

        </div>
      ))}

      <button style={{ marginTop: "40px"}} type="button" onClick={addQuestion} disabled={saving}>
        + Aggiungi domanda
      </button>
    </div>
  );
}

export default ExamManager;